import { render, staticRenderFns } from "./RappelsFormComponent.vue?vue&type=template&id=356ea45c&"
import script from "./RappelsFormComponent.vue?vue&type=script&lang=js&"
export * from "./RappelsFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports